interface BuildTeamGradientParams {
  baseColor: string
  teamColor: string
}

/**
 * Linear gradient at 113deg, fading from the team color into the palette's
 * `background-600` shade — matches the reference design (Figma "Experiencia
 * · Equipo favorito", node 853:50694; cross-checked full-page at node
 * 866:32541). Angle/stops were tuned visually against a running dev server,
 * not derived analytically — re-tune the same way if they ever need
 * revisiting, don't guess from this file alone.
 *
 * `var(--background-600, baseColor)` prefers the live palette var (so a
 * palette change is picked up automatically) — `baseColor` is that same
 * `background-600` shade resolved by the caller, so the fallback is just a
 * safety net, not a distinct value. Lowercase `background-600` matters — CSS
 * custom properties are case-sensitive and `generateColorStyles`
 * (generateColorShades.ts) always emits lowercase `--{category}-{key}` names.
 */
export function buildTeamGradient({ baseColor, teamColor }: BuildTeamGradientParams): string {
  return `linear-gradient(113deg, ${teamColor} 0%, var(--background-600, ${baseColor}) 25%, var(--background-600, ${baseColor}) 88.58%)`
}
